import React from 'react';
import nanoid from 'nanoid';
import getEnvironDomain from 'utils/getEnvironDomain';
import PopupLink from 'ati-ui-react/components/PopupLink';
import ReactTooltip from 'ati-ui-react/components/ReactTooltip';

import useWindowSize from 'hooks/useWindowSize';
import { FactsStyles } from './FactsStyles';

function Facts({ account, stars, ml }) {
  const [width] = useWindowSize();
  const hasTrafficLightIcon = !!stars?.traffic_light_icon;
  const hasReputationSignalIcon = !!stars?.reputation_signal_icon;
  const hasIcon = hasTrafficLightIcon || hasReputationSignalIcon;

  if (!hasIcon) return null;

  const id = nanoid();
  // Удаляем теги из строки
  const trafficText = stars?.traffic_light_icon?.body.replace(/<[^>]*>?/gm, '');
  const signalText = stars?.reputation_signal_icon?.body.replace(/<[^>]*>?/gm, '');

  return (
    <>
      {hasTrafficLightIcon && (
        <FactsStyles ml={ml} onClick={(e) => e.stopPropagation()}>
          <PopupLink href={`//${getEnvironDomain()}/firms/${account?.account_id}/rating`}>
            <div data-for={`traffic-${id}`} data-tip>
              <img src={stars?.traffic_light_icon?.image_link} height="14px" alt="" />
            </div>
            {width > 1023 && (
              <ReactTooltip data-tip aria-haspopup="true" effect="solid" id={`traffic-${id}`}>
                <span>{trafficText}</span>
              </ReactTooltip>
            )}
          </PopupLink>
        </FactsStyles>
      )}
      {hasReputationSignalIcon && (
        <FactsStyles ml={ml} onClick={(e) => e.stopPropagation()}>
          <PopupLink href={`//${getEnvironDomain()}/firms/${account?.account_id}/rating`}>
            <div data-for={`signal-${id}`} data-tip>
              <img
                src={stars?.reputation_signal_icon?.image_link}
                height="20px"
                alt=""
                style={{ marginTop: '3px' }}
              />
            </div>
            {width > 1023 && (
              <ReactTooltip data-tip aria-haspopup="true" effect="solid" id={`signal-${id}`}>
                <span>{signalText}</span>
              </ReactTooltip>
            )}
          </PopupLink>
        </FactsStyles>
      )}
    </>
  );
}

export default Facts;
